import React, { useContext, useState } from 'react'
import VaccinationStockList from '../../../common/stock/VaccinationStockList'
import StockForm, { StockListFormValues } from '../../../common/stock/StockForm'
import PageLayout from '../../../../components/layout/PageLayout'
import { SELECT_VALUES } from '../../../../utils/constants'
import { RequestStockFiltersModel, ResponseStockModel } from '../../../admin/stock/services/stockModel'
import DialogEditStock from '../../../admin/stock/DialogEditStock'
import { OfflineContext } from '../../../common/offline/context/OfflineContext'

const StockVaccination = () => {
    const { offlineMode } = useContext(OfflineContext)
    const [filters, setFilters] = useState<RequestStockFiltersModel>({
        idProduit: undefined,
        quantiteNonNulle: true,
        onlyRetour: false
    })
    const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState<ResponseStockModel | undefined>(undefined)
    const openDialog = (row: ResponseStockModel) => {
        setSelectedRow(row)
        setIsOpenDialog(true)
    }
    const closeDialog = () => setIsOpenDialog(false)

    const getStocks = (formValues: StockListFormValues) => {
        setFilters({
            idProduit: formValues.idProduit === SELECT_VALUES.ALL ? undefined : formValues.idProduit,
            lot: formValues.batchNumber,
            quantiteNonNulle: !formValues.isVisibleOutOfStock,
            onlyRetour: formValues.onlyRetour
        })
    }

    return (
        <PageLayout>
            <StockForm onSubmit={getStocks} showEmptyStock={!offlineMode} />
            <VaccinationStockList
                filters={filters}
                openDialog={openDialog}
                isOpenDialog={isOpenDialog}
                showActions
            />
            {selectedRow && <DialogEditStock
                isOpen={isOpenDialog}
                handleClose={closeDialog}
                selectedRow={selectedRow}
            />}
        </PageLayout>
    )
}

export default StockVaccination
